const ELEMENTS_CSS = 'https://img.dsers.com/element-doc/styles.min.css';
const ELEMENTS_JS = 'https://img.dsers.com/element-doc/web-components.min.js';

let loadingPromise = null;

export function setElementsStylesEnabled(enabled) {
  const link = document.querySelector(
    `link[data-elements-doc="true"], link[href="${ELEMENTS_CSS}"]`
  );
  if (link) link.disabled = !enabled;
}

export function loadElementsDoc() {
  if (loadingPromise) {
    setElementsStylesEnabled(true);
    return loadingPromise;
  }

  loadingPromise = new Promise((resolve, reject) => {
    const ensureCss = () => {
      let link = document.querySelector(`link[href="${ELEMENTS_CSS}"]`);
      if (!link) {
        link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = ELEMENTS_CSS;
        link.dataset.elementsDoc = 'true';
        document.head.appendChild(link);
      }
      link.disabled = false;
    };

    const ensureJs = () => {
      if (window.customElements?.get('elements-api')) {
        resolve();
        return;
      }
      const existing = document.querySelector(`script[src="${ELEMENTS_JS}"]`);
      if (existing) {
        existing.addEventListener('load', () => resolve());
        existing.addEventListener('error', reject);
        if (window.customElements?.get('elements-api')) resolve();
        return;
      }
      const script = document.createElement('script');
      script.src = ELEMENTS_JS;
      script.onload = () => resolve();
      script.onerror = reject;
      document.head.appendChild(script);
    };

    ensureCss();
    ensureJs();
  });

  return loadingPromise;
}
